const prefix = '/invoices';

export const routes = {
  DETAILS: `${prefix}/details`,
  LIST: `${prefix}`,
};
